import { Directive, HostBinding, Input } from '@angular/core';

/**
 * enums
*/
import { IThemeColorVariant } from '@core/enums/theme-colors-variants';
import { BadgeAppearance, IBadgeAppearance } from './enums/badge-appearance';

@Directive({
  selector: '[appBadge]',
  host: {
    '[class.badge]': 'true',
  }
})
export class BadgeDirective {

  /**
   * @description element prefix for classStyle
   */
  private _prefix: string = 'badge';

  //--------------------------------------------------------------------------
  // Inputs (Configuration)
  //--------------------------------------------------------------------------  

  /**
   * @description bootstrap Variants ( Primary, etc.. )
   */
  @Input({ alias: 'appBadge', required: true })
  public variant!: IThemeColorVariant;

  
  /**
   * @description bootstrap Appearance ( Outline, Solid )
   */
  @Input({ alias: "appearance" })
  public appearance?: IBadgeAppearance;

  /**
   * @description if `true` add bg-glow class in badge
   */
  @HostBinding('class.bg-glow')
  @Input({ alias: "glow" })
  public isGlow: boolean = false;

  /**
   * @description if true add rounded-pill class in badge
   */
  @HostBinding('class.rounded-pill')
  @Input({ alias: "rounded" })
  public rounded: boolean = false;

  /**
   * @description if true add badge-center class in badge
   */
  @HostBinding('class.badge-center')
  @Input({ alias: "center" })
  public center: boolean = false;

  /**
   * @description if true add badge-notifications class in badge
   */
  @HostBinding('class.badge-notifications')
  @Input({ alias: "notifications" })
  public isNotifications: boolean = false;

  /**
   * @description if true add badge-badge-dot class in badge
   */
  @HostBinding('class.badge-dot')
  @HostBinding('class.me-1')
  @Input({ alias: "dot" })
  public isDot: boolean = false;

  /**
   * @description handler badge ui depend on variant with appearance
   */
  @HostBinding('class')
  public get buildAlertClass(): string {

    // init
    const classMapping: string[] = [];

    // build badge type
    if (this.appearance && typeof this.appearance == 'string') {

      // Convert string to lowercase
      const _key = this.appearance.toLowerCase()

      // handler appearance cases
      switch(this.appearance) {
        // and prefix with outline
        case BadgeAppearance.Outline:
          classMapping.push(this._prefix);
          classMapping.push(_key);
          break;
        case BadgeAppearance.Label:
          classMapping.push(`bg-${_key}`);
          break;
        case BadgeAppearance.Text:
          classMapping.push(`${_key}-bg`);
          break;
      }

    }
    else {
      // default case without appearances
      classMapping.push('bg');
    }

    // add variant to end of string
    if (typeof this.variant == 'string') classMapping.push(this.variant.toLowerCase());

    return classMapping.join('-');

  }  

  constructor() { }

}
